import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/FutureFeatures.module.css';

const features = [
  {
    id: 'ai-assistant',
    title: '관리자 페이지 AI 도우미',
    description: '배울 필요 없이 AI에게 명령해서 더 쉽게 사용',
    details: [
      '채팅이나 음성으로 일정 관리',
      '고객 관리 기능을 AI로 쉽게 활용',
      '새로운 솔루션 러닝 커브 최소화'
    ],
    icon: '🤖'
  },
  {
    id: 'simple-feedback',
    title: '종목별 키워드 간편 피드백',
    description: '코치님들의 부담은 최소화하고, 고객의 만족도는 최대화',
    details: [
      '터치 몇 번으로 쉽게 피드백 작성',
      '종목별로 최적화된 키워드 제공',
      '네이버 예약 리뷰처럼 간편하게'
    ],
    icon: '📝'
  }
];

export default function FutureFeatures() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section ref={ref} className={`section ${styles.futureFeatures}`}>
      <div className="section-content">
        <h2 className={`text-center ${styles.title}`}>
          올림이 앞으로 <span className={styles.highlight}>제공할 기능</span>
        </h2>
        <p className={`text-center ${styles.subtitle}`}>
          더 나은 센터 운영을 위해 준비하고 있습니다
        </p>

        <div className={`${styles.featuresGrid} ${isVisible ? styles.visible : ''}`}>
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className={styles.featureCard}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className={styles.iconWrapper}>
                <span className={styles.icon}>{feature.icon}</span>
              </div>
              <h3 className={styles.cardTitle}>{feature.title}</h3>
              <p className={styles.cardDescription}>{feature.description}</p>
              <ul className={styles.detailsList}>
                {feature.details.map((detail, i) => (
                  <li key={i}>
                    <svg viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    {detail}
                  </li>
                ))}
              </ul>
              <div className={styles.comingSoon}>
                <span className={styles.badge}>Coming Soon</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
